const nav_de = {
  dashboard: 'Dashboard',
  users: 'Benutzer',
  items: 'Artikel',
  myPlans: 'Meine Pläne',
  categories: 'Kategorien',
  tags: 'Tags',
  manual: 'Handbuch',
  adminHubBanner: 'Angemeldet als {name} über Admin Hub',
  adminHubBannerNoName: 'Angemeldet über Admin Hub',
  adminHubLogout: 'Abmelden',
  logout: 'Abmelden',
  customerSwitch: {
    trigger: 'Aktiver Kunde: {name}. Kunde wechseln',
    title: 'Kunde wechseln',
    customerNo: 'Kd.-Nr. {number}',
    current: 'Aktuell aktiv',
    sessionNote: 'Gilt nur für diese Sitzung auf diesem Gerät.',
    switched: 'Sie arbeiten jetzt in {name}',
    confirmTitle: 'Nicht gespeicherte Änderungen verwerfen?',
    confirmBody:
      'Auf dieser Seite gibt es nicht gespeicherte Änderungen. Beim Wechsel zu {name} wird die Anwendung neu geladen und die Änderungen gehen verloren.',
    confirm: 'Trotzdem wechseln',
    cancel: 'Abbrechen',
  },
  tenantSwitch: {
    title: 'work4all-Mandant',
    tenantNo: 'Mandant {code}',
    readOnly: 'nur lesen',
    trigger: 'Mandant: {name} – wechseln',
    loginNote: 'Beim Wechsel melden Sie sich am anderen Mandanten neu an.',
    locked: 'gesperrt, meldet nicht „nur lesen“',
    liveConfirmTitle: 'Zu den echten Daten wechseln?',
    liveConfirmBody:
      '{name} enthält die echten Daten von LA CONCEPT. Sein Backend ist nur lesend angebunden: Änderungen an work4all sind dort gesperrt. Beim Wechsel werden Sie abgemeldet.',
    liveConfirm: 'Wechseln',
    confirmTitle: 'Nicht gespeicherte Änderungen verwerfen?',
    confirmBody:
      'Auf dieser Seite gibt es nicht gespeicherte Änderungen. Beim Wechsel zu {name} werden Sie abgemeldet und die Änderungen gehen verloren.',
    confirm: 'Trotzdem wechseln',
    cancel: 'Abbrechen',
  },
}

export default nav_de
